















































































































































import { Component, Vue } from 'vue-property-decorator';
import RecruitmentNavigationDrawer from '@/components/recruitment/RecruitmentNavigationDrawer.vue';
import CommonButton from '@/components/common/CommonButton.vue';
import OrganizationIcon from '@/components/common/OrganizationIcon.vue';

interface PageOption {
  count: number;
  max: number;
  min: number;
  current: number;
}

@Component({
  components: {
    RecruitmentNavigationDrawer,
    CommonButton,
    OrganizationIcon,
  },
})

export default class JobListBase extends Vue {
  commonButtonColorCreate: string = 'rgba(76, 132, 253, 0.8)'
  /** 表示するタブの初期状態 */
  private activeTab: string = 'all';

  /** 表示するタブを切り替える関数 */
  private selectedTab(tabName: string): void {
    this.activeTab = tabName;
  }

  private pageOption: PageOption = {
    count: 10,
    max: 5,
    min: 1,
    current: 1,
  }

  private onPushRouter(routeName: string) {
    this.$router.push({ name: routeName });
  }
}
